import { render, staticRenderFns } from "./SelectCurator.vue?vue&type=template&id=0b8d8795"
import script from "./SelectCurator.vue?vue&type=script&lang=ts"
export * from "./SelectCurator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports